<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="fmh" id="_idParaDest-1"><a id="_idTextAnchor000"></a><a href="#/text/9780062653710_Contents#r_idParaDest-1"><span class="right_1" epub:type="pagebreak" id="page_v" title="v">DEDICATION</span></a></h2>
<p class="dedi">To my siblings: Rachel, Ben, and Hannah—</p>
<p class="dedi">I can’t wait to see where your journeys lead</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062653710_Dedication.vue?49a73f8e